export async function getPaymentMethods(service) {
  try {
    const response = await service.get("/org/list_available_methods");
    console.log(response);
    // Check if response and payment_methods exists
    if (!response || !response.methods) {
      throw new Error("Invalid response structure from server");
    }

    // Transform response to match our frontend format
    const paymentMethods = response.methods.map((method) => ({
      id: method.id,
      brand: method.card?.brand || "Unknown",
      last4: method.card?.last4 || "****",
      exp_month: method.card?.exp_month?.toString() || "MM",
      exp_year: method.card?.exp_year?.toString().slice(-2) || "YY",
      isDefault: method.id === response.current_method_id,
    }));

    return {
      paymentMethods,
      defaultPaymentMethodId: response.current_method_id,
    };
  } catch (error) {
    console.error("Error fetching payment methods:", error);
    // Return empty array if error occurs
    return {
      paymentMethods: [],
      defaultPaymentMethodId: null,
    };
  }
}

export async function attachPaymentMethod(
  service,
  { paymentMethodId, setAsDefault = false }
) {
  try {
    const response = await service.post("/org/attach_billing_method", {
      method_id: paymentMethodId,
      set_as_default: setAsDefault,
    });
    return response;
  } catch (error) {
    console.error("Error attaching payment method:", error);
    throw error;
  }
}

export async function removePaymentMethod(service, paymentMethodId) {
  try {
    const response = await service.post("/org/remove_payment_method", {
      method_id: paymentMethodId,
    });
    return response;
  } catch (error) {
    console.error("Error removing payment method:", error);
    throw error;
  }
}

export async function getOrgDetails(service) {
  try {
    const response = await service.get("/org/details");

    return {
      name: response.name,
      created_at: response.created_at,
      unique_name: response.unique_name,
      active: response.active,
      previous_billing_date: response.previous_billing_date,
      next_billing_date: response.next_billing_date,
      billing_email: response.billing_email,
    };
  } catch (error) {
    console.error("Error fetching org details:", error);
    throw error;
  }
}

export async function updateOrgBillingEmail(service, billingEmail) {
  try {
    const response = await service.put("/org/update_org_billing_details", {
      billing_email: billingEmail,
    });

    return response;
  } catch (error) {
    console.error("Error updating billing email:", error);
    throw error;
  }
}
